import type { AuditLog } from '@/features/external-users/types/audit-log.types';

/**
 * Ce qu'une ligne d'historique contient de brut, pour le bloc technique replié
 * — sous les noms des colonnes, que les développeurs retrouvent en base.
 * `null` quand il n'y a rien d'autre que le code de l'action.
 */
export const technicalData = (log: AuditLog): Record<string, unknown> | null => {
  const data: Record<string, unknown> = {
    action: log.action,
    changesSummary: log.changesSummary,
    oldData: log.oldData,
    newData: log.newData,
    stepName: log.stepName,
    stepNumber: log.stepNumber,
    durationMs: log.durationMs,
    correlationId: log.correlationId,
  };
  const remplies = Object.entries(data).filter(
    ([, valeur]) => valeur !== undefined && valeur !== null && valeur !== '',
  );
  return remplies.length > 1 ? Object.fromEntries(remplies) : null;
};
